import { jsx, jsxs } from "react/jsx-runtime";
import { CommandItem } from "../../_shadcn-native-components/command.js";
import { cn } from "../../utils.js";
import { sanitizeText } from "../utils/sanitize-text.js";
const DropdownUserItem = ({ user, value, selected, className, onSelect, ...itemProps })=>/*#__PURE__*/ jsx(CommandItem, {
        value: value,
        searchKey: user.name,
        selected: selected,
        onSelect: ()=>onSelect(value),
        className: cn('tw-h-5.6 tw-py-0.8', selected && 'tw-bg-neutral-light-300 dark:tw-bg-neutral-dark-600', className),
        ...itemProps,
        children: /*#__PURE__*/ jsxs("div", {
            className: "tw-flex tw-items-center tw-gap-0.8",
            children: [
                /*#__PURE__*/ jsx("img", {
                    src: user.avatar,
                    alt: user.name,
                    className: "tw-h-3.2 tw-w-3.2 tw-rounded-full"
                }),
                /*#__PURE__*/ jsxs("div", {
                    className: "tw-flex tw-flex-col tw-justify-between tw-h-4",
                    children: [
                        /*#__PURE__*/ jsx("div", {
                            className: "tw-font-subtitle5 tw-line-clamp-1",
                            children: sanitizeText(user.name)
                        }),
                        /*#__PURE__*/ jsx("div", {
                            className: "tw-font-body5 tw-line-clamp-1 tw-text-neutral-light-700 dark:tw-text-neutral-dark-300",
                            children: sanitizeText(user.position)
                        })
                    ]
                })
            ]
        })
    });
export { DropdownUserItem };
